import { Skeleton } from '@shared/components/shadcn';
import { InnerPageContainer } from '../../InnerPageContainer/InnerPageContainer';
import { Summary, SummaryContent } from '../../Summary/Summary';

function PageHeaderSkeleton() {
  return (
    <div className="ll-container-inner flex items-center gap-3">
      <Skeleton className="h-6 w-6 rounded" />
      <Skeleton className="h-7 w-32" />
    </div>
  );
}

function PurchaseSummarySkeleton() {
  return (
    <Summary className="ll-container-inner">
      <SummaryContent>
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="paragraph-s flex justify-between items-center">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-32" />
          </div>
        ))}
      </SummaryContent>
    </Summary>
  );
}

function DrawSelectorSkeleton() {
  return (
    <div className="ll-container-full px-[var(--ll-container-padding)] flex gap-x-4 overflow-x-hidden">
      {Array.from({ length: 8 }).map((_, index) => (
        <div key={index} className="flex flex-col items-center justify-center gap-3 w-14">
          <div className="relative w-full">
            <Skeleton className="h-16 w-full rounded-lg bg-background border border-border" />
          </div>
          <Skeleton className="h-3 w-14 rounded-full" />
        </div>
      ))}
    </div>
  );
}

function WinningsSkeleton() {
  return (
    <div className="ll-container-inner flex items-center justify-between py-2">
      <Skeleton className="h-6 w-32" />
      <div className="flex items-center gap-2">
        <Skeleton className="h-6 w-6 rounded-full bg-success" />
        <Skeleton className="h-6 w-28" />
      </div>
    </div>
  );
}

function ResultsSkeleton() {
  return (
    <div className="ll-container-inner flex flex-col gap-4">
      <hr className="ll-container-inner h-px border-t-border mb-4" />
      <div className="flex items-center justify-between">
        <Skeleton className="h-6 w-20" />
        <div className="flex items-center gap-2">
          <Skeleton className="h-5 w-5 rounded-full bg-success" />
          <Skeleton className="h-5 w-24" />
        </div>
      </div>
      <div className="flex justify-center gap-2 px-4 py-3 border border-border rounded-full bg-background">
        {Array.from({ length: 5 }).map((_, index) => (
          <Skeleton key={index} className="h-8 w-8 rounded-full" />
        ))}
      </div>
      <Skeleton className="h-4 w-40" />
    </div>
  );
}

function ParticipationInfoSkeleton() {
  return (
    <div className="ll-container-full ll-grid-container gap-y-5">
      <DrawSelectorSkeleton />
      <hr className="ll-container-inner h-px border-t-border" />
      <WinningsSkeleton />
      <ResultsSkeleton />
    </div>
  );
}

function YourNumbersSkeleton() {
  return (
    <div className="ll-container-inner flex flex-col gap-5">
      <div className="flex items-center gap-2 justify-between">
        <Skeleton className="h-6 w-32" />
        <Skeleton className="h-5 w-16" />
      </div>
      <div className="flex flex-col gap-3">
        {Array.from({ length: 3 }).map((_, index) => (
          <div key={index} className="flex justify-center gap-2 px-4 py-3 border border-border rounded-full bg-background">
            {Array.from({ length: 5 }).map((_, numIndex) => (
              <Skeleton key={numIndex} className="h-8 w-8 rounded-full" />
            ))}
          </div>
        ))}
      </div>
      <Skeleton className="h-4 w-32" />
    </div>
  );
}

function SummarySkeleton() {
  return (
    <Summary className="ll-container-inner">
      <SummaryContent>
        <div className="paragraph-s flex justify-between items-center">
          <Skeleton className="h-4 w-48" />
          <Skeleton className="h-4 w-16" />
        </div>
      </SummaryContent>
    </Summary>
  );
}

function PurchaseDetailsPageLoading() {
  return (
    <InnerPageContainer>
      <div className="ll-grid-container gap-y-8 pt-4 pb-10 sm-md:pt-10 sm-md:[--ll-container-padding:40px]">
        <PageHeaderSkeleton />
        <PurchaseSummarySkeleton />
        <ParticipationInfoSkeleton />
        <hr className="ll-container-inner h-px border-t-border" />
        <YourNumbersSkeleton />
        <SummarySkeleton />
      </div>
    </InnerPageContainer>
  );
}

export { PurchaseDetailsPageLoading };
